import React, { useEffect, useRef, useState } from "react";

const ResponsiveContainer = ({
  children,
  originalDimensions,
  className,
  style,
  ...props
}: {
  children: React.ReactNode;
  originalDimensions: `${number}x${number}`;
} & React.HTMLAttributes<HTMLDivElement>) => {
  const [originalWidth, originalHeight] = originalDimensions
    .split("x")
    .map(Number);
  const thisRef = useRef<HTMLDivElement>(null);

  const [scale, setScale] = useState(1);
  const [marginBottomAdjustment, setMarginBottomAdjustment] = useState(0);

  const scaleThis = (width: number) => {
    const responsiveContainer = thisRef.current;
    if (!responsiveContainer) return;
    if (width > originalWidth) {
      setScale(1);
      setMarginBottomAdjustment(0);
      return;
    }
    const scale = width / originalWidth;
    setScale(scale);
    const newHeight = originalHeight * scale;
    setMarginBottomAdjustment(originalHeight - newHeight);
  };

  useEffect(() => {
    const responsiveContainer = thisRef.current;
    if (!responsiveContainer) return;
    console.log("responsive container", responsiveContainer);
    scaleThis(responsiveContainer.offsetWidth);
    const obs = new ResizeObserver((entries) => {
      scaleThis(entries[0].borderBoxSize[0].inlineSize);
    });
    obs.observe(responsiveContainer);

    return () => {
      obs.disconnect();
    };
  }, [thisRef]);

  return (
    <div
      className={`relative w-full overflow-hidden flex items-center justify-center ${
        className ?? ""
      }`}
      ref={thisRef}
      style={{
        // marginBottom: `${-marginBottomAdjustment}px`,
        height: `${originalHeight * scale}px`,
        ...style,
      }}
      {...props}
    >
      <div
        className="absolute shrink-0"
        style={{
          scale: `${scale}`,
          height: `${originalHeight}px`,
          width: `${originalWidth}px`,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default ResponsiveContainer;
